export default __webpack_public_path__ + "static/media/logo.ea9773b5.svg";